import { useQuery } from "@tanstack/react-query";
import { getMessageNotifications } from "@/services/notification.service";
import { useChatUnreadStore } from "@/store/chat-unread-store";
import { getCookie } from "cookies-next";
import { COOKIE_CONFIG } from "@/config";

/**
 * Hook to fetch and manage the unread message notification count
 */
export const useMessageNotificationCount = (isLoggedIn: boolean | null) => {
  const activeChatId = useChatUnreadStore((state) => state.activeProposalId);

  return useQuery({
    queryKey: ["unreadMessageNotificationCount"],
    queryFn: () => getMessageNotifications({ pageSize: 1, pageNumber: 1 }),
    enabled: !!isLoggedIn && !!getCookie(COOKIE_CONFIG.loggedIn),
    // Map the response to just return the count for simplicity in UI components
    select: (response) => response.data.count,
    refetchOnWindowFocus: true,
  });
};
